<div>
  <form [formGroup]="rabatForm" [attr.autocomplete]="'off'">
    <mat-form-field>
      <mat-label>Forudfyld fra kampagne</mat-label>
      <mat-select formControlName="rabatkampagne" (selectionChange)="onRabatkampagneChanged($event.value)">
        @for (rabatkampagnen of rabatkampagnerSortedByName; track rabatkampagnen) {
          <mat-option [value]="rabatkampagnen">
            {{ rabatkampagnen.name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
    </mat-form-field>
  </form>
  <app-rabat-form
    [rabatForm]="rabatForm"
    [isPrivatKunde]="isPrivatKunde"
    [maxKontantRabat]="maxKontantRabat"
    class="margin-top"
  ></app-rabat-form>
</div>
